"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteEmailTemplate = void 0;
/**
 * Delete an email template from the database by id
 */
var deleteEmailTemplate = function (instance) { return function (id, config) {
    return instance.delete("/emails/templates/".concat(id), config);
}; };
exports.deleteEmailTemplate = deleteEmailTemplate;
